/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { Translator } from 'ggApp/modules/translator';
import { StoreComponent_StoreShowPrice as ShowPrice } from 'ggApp/modules/store';
import { showDiscount } from 'ggApp/utils/text';

import {
    Container, Cell, Row, TaxNote,
} from './styles';

const SummarySection = ({
    className,
    order: {
        currencySymbol,
        subtotal,
        shipping,
        discount,
        voucherDiscount,
        total,
    },
}) => (
    <Container className={className}>
        <Row>
            <Cell>
                <Translator tk="SUBTOTAL" />
            </Cell>
            <Cell>
                <ShowPrice
                    price={subtotal}
                    orderCurrencySymbol={currencySymbol}
                />
            </Cell>
        </Row>
        <Row>
            <Cell>
                <Translator tk="SHIPPING" />
            </Cell>
            <Cell>
                <ShowPrice
                    price={shipping}
                    orderCurrencySymbol={currencySymbol}
                />
            </Cell>
        </Row>
        {!!discount && parseFloat(discount) !== 0 && (
            <Row>
                <Translator tk="DISCOUNT" />
                <Cell>
                    -
                    <ShowPrice
                        price={showDiscount(discount)}
                        orderCurrencySymbol={currencySymbol}
                    />
                </Cell>
            </Row>
        )}

        {!!voucherDiscount && parseFloat(voucherDiscount) !== 0 && (
            <Row>
                <Translator tk="VOUCHER" />
                <Cell>
                    -
                    <ShowPrice
                        price={voucherDiscount}
                        orderCurrencySymbol={currencySymbol}
                    />
                </Cell>
            </Row>
        )}

        <Row>
            <Cell bold>
                <Translator tk="TOTAL" />
                <TaxNote>
                    <Translator tk="TAX_APPLY" />
                </TaxNote>
            </Cell>
            <Cell bold>
                <ShowPrice
                    price={total}
                    orderCurrencySymbol={currencySymbol}
                />
            </Cell>
        </Row>
    </Container>
);

SummarySection.propTypes = {
    className: PropTypes.string,
    order: PropTypes.shape({
        currencySymbol: PropTypes.string,
        subtotal: PropTypes.string,
        shipping: PropTypes.string,
        discount: PropTypes.string,
        voucherDiscount: PropTypes.string,
        total: PropTypes.string,
    }),

};

SummarySection.defaultProps = {
    className: '',
    order: PropTypes.shape({
        currencySymbol: '',
        subtotal: '',
        shipping: '',
        discount: '',
        voucherDiscount: '',
        total: '',
    }),
};
export default SummarySection;
